import { Component, OnInit } from '@angular/core';
import { IUser } from '@shared/auth/auth.models';
import { AuthService } from '@shared/auth/auth.service';
import { Router,NavigationStart} from '@angular/router';

@Component({
  selector: 'app-profile-settings',
  templateUrl: './settings.component.html',
})
export class ProfileSettingsComponent implements OnInit {
  user: IUser = null;
  processing: boolean = false;

  constructor(private authService: AuthService, private router: Router) {
  }

  ngOnInit() {
    this.processing = true;
    if(!this.authService.isAuthenticated()) {  
      this.router.navigate(['/error/403'])
    }
    this.user = this.authService.getUser();

    this.processing = false;
  }
}
